import { AdminList, AdminDataGrid, GridColumn } from './shared';
/**
 * Card List Component
 * Displays paginated list of profile cards with category and status filters
 */

import {
  TextField,
  DateField,
  SearchInput,
  SelectInput,
  ReferenceInput,
  useRecordContext,
} from 'react-admin';
import { Chip, Typography } from '@mui/material';
import { semantic } from '@rekindle/shared/theme';
import { CARD_STATUS_CHOICES } from '../constants';
import { ListActions } from './shared';

/**
 * Status color mapping
 */
const STATUS_COLORS: Record<string, string> = {
  active: semantic.success,
  inactive: semantic.neutral,
  draft: semantic.warning,
};

/**
 * Custom field to display card status with color coding
 */
function StatusField() {
  const record = useRecordContext();
  if (!record?.status) return null;

  const status = record.status.toLowerCase();
  const color = STATUS_COLORS[status] || STATUS_COLORS.inactive;

  return (
    <Chip
      label={record.status}
      size="small"
      sx={{
        backgroundColor: color,
        color: 'white',
        textTransform: 'capitalize',
      }}
    />
  );
}

/**
 * Custom field to display category
 */
function CategoryField() {
  const record = useRecordContext();
  if (!record?.categoryName) {
    return <Typography variant="body2" color="textSecondary">-</Typography>;
  }

  return (
    <Chip
      label={record.categoryName}
      size="small"
      variant="outlined"
    />
  );
}

/**
 * Filters for card list
 */
const cardFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Search cards..." />,
  <ReferenceInput
    key="categoryId"
    source="categoryId"
    reference="content/categories"
    label="Category"
  >
    <SelectInput optionText="name" optionValue="id" label="Category" />
  </ReferenceInput>,
  <SelectInput
    key="status"
    source="status"
    label="Status"
    choices={CARD_STATUS_CHOICES}
  />,
];

export function CardList() {
  return (
    <AdminList
      filters={cardFilters}
      actions={<ListActions />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      perPage={25}
    >
      <AdminDataGrid bulkActionButtons={false} rowClick="edit" omit={['id']}>
        <TextField source="id" label="ID" />
        <TextField source="statement" label="Statement" />
        <GridColumn label="Category" source="categoryName"><CategoryField /></GridColumn>
        <GridColumn label="Status" source="status"><StatusField /></GridColumn>
        <DateField source="createdAt" label="Created" showTime />
      </AdminDataGrid>
    </AdminList>
  );
}
